import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from '../packs/online-ordering/src/App.vue'
import router from '../packs/online-ordering/src/router'
import VueDatePicker from '@vuepic/vue-datepicker';
import  VueGoogleMaps from '@fawmi/vue-google-maps';
import VueGtag from 'vue-gtag';
import '@vuepic/vue-datepicker/dist/main.css';
import '../packs/online-ordering/src/assets/online_ordering_app.css';

// import {default as helpers} from '../partials/online-catering-helpers.js';

const online_ordering_app = createApp(App);

online_ordering_app.use(createPinia());
online_ordering_app.use(router);
online_ordering_app.component('VueDatePicker', VueDatePicker);

online_ordering_app.use(VueGoogleMaps, {
    load: {
      version: 3.53,
      v: 3.53,
      libraries: "places",
      key: 'AIzaSyAfEIL5nySYCeOA47vWOYTbeKdO_UsnREk',
    },
})

// Not a great way to do this; but here's a helper for pluralizing product names
online_ordering_app.config.globalProperties.pluralizeProductName = (name, quantity) => {
  if (quantity != 1) {
    let words = name.split(' ');
    const lastWord = words[words.length - 1];

    let replacementWord = lastWord.toString(); // To string it so we have a baseline to fall back to without the reference

    switch (lastWord.toLowerCase()) {
    case 'box':
      replacementWord = "boxes"
      break;
    case 'lunch':
      replacementWord = "lunches"
      break;
    case 'pan':
      replacementWord = "pans"
      break;
    case 'pack':
      replacementWord = "packs"
      break;
    case 'gallon':
      replacementWord = "gallons"
      break;
    default:
      // We technically don't need most of the plural forms above, as the default would be fine
      replacementWord = replacementWord + 's'
      break;
    }

    replacementWord = replacementWord.charAt(0).toUpperCase() + replacementWord.slice(1);

    words.splice(words.indexOf(lastWord), 1, replacementWord);

    return words.join(' ')
  } else {
    return name;
  }
}

let ga_measurement_id = ""
if (window.location.host == "mypiada.com") {
  ga_measurement_id = "G-4EDF1J8BB4";
} else {
  ga_measurement_id = "G-BQ1HLCT0C8";
}

online_ordering_app.use(VueGtag, {
  config: {
    id: ga_measurement_id,
  }
}, router)


online_ordering_app.mount('#online-ordering-app')